import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

type BaseHttpParams =
    | HttpParams
    | {
          [param: string]: string | string[] | number | boolean;
      };

type BaseHttpHeaders =
    | HttpHeaders
    | {
          [header: string]: string | string[];
      };

type BaseBody = any | null;

export abstract class ApiBaseService {
    public formatErrors = (error: any) => {
        return observableThrowError(error);
    };
    public fullUrl = (action: string): string => {
        return (this.prefixUrl || '') + (this.controllerUrl || '') + (action || '');
    };
    public get = <T>(
        action: string,
        params?: BaseHttpParams,
        headers?: BaseHttpHeaders,
    ): Observable<T> => {
        return this.http
            .get<T>(this.fullUrl(action), { params, headers })
            .pipe(catchError(this.formatErrors));
    };
    public put = <T>(action: string, body: BaseBody, headers?: BaseHttpHeaders): Observable<T> => {
        return this.http
            .put<T>(this.fullUrl(action), body, { headers })
            .pipe(catchError(this.formatErrors));
    };
    public post = <T>(action: string, body: BaseBody, headers?: BaseHttpHeaders): Observable<T> => {
        return this.http
            .post<T>(this.fullUrl(action), body, { headers })
            .pipe(catchError(this.formatErrors));
    };
    public delete = <T>(action: string, headers?: BaseHttpHeaders): Observable<T> => {
        return this.http
            .delete<T>(this.fullUrl(action), { headers })
            .pipe(catchError(this.formatErrors));
    };
    public patch = <T>(
        action: string,
        body: BaseBody,
        headers?: BaseHttpHeaders,
    ): Observable<T> => {
        return this.http
            .patch<T>(this.fullUrl(action), body, { headers })
            .pipe(catchError(this.formatErrors));
    };

    public save = <T>(action: string, headers?: BaseHttpHeaders): Observable<T> => {
        const requestOptions: object = {
            responseType: 'blob',
        };

        return this.http.get<T>(this.fullUrl(action), requestOptions);
    };

    public exportFile = <T>(
        action: string,
        params?: BaseHttpParams,
        headers?: BaseHttpHeaders,
    ): Observable<T> => {
        const requestOptions: object = {
            responseType: 'blob',
            observe: 'response',
            params,
            headers,
        };

        return this.http
            .get<T>(this.fullUrl(action), requestOptions)
            .pipe(catchError(this.formatErrors));
    };

    public savePost = <T>(
        action: string,
        body: BaseBody,
        headers?: BaseHttpHeaders,
        observe: 'body' | 'response' = 'body',
    ): Observable<any> => {
        return this.http.post<T>(this.fullUrl(action), body, {
            // @ts-ignore
            responseType: 'blob',
            observe: observe as 'body',
        });
    };
    public saveGet = <T>(
        action: string,
        params: BaseBody,
        headers?: BaseHttpHeaders,
        observe: 'body' | 'response' = 'body',
    ): Observable<any> => {
        return this.http.get<T>(this.fullUrl(action), {
            params,
            // @ts-ignore
            responseType: 'blob',
            observe: observe as 'body',
        });
    };

    constructor(
        public http: HttpClient,
        protected controllerUrl: string,
        protected prefixUrl: string = 'v1',
    ) {}
}
